// src/pages/RecuperarContrasena.js
// =========================================================================
// «He olvidado mi contraseña»: pide el correo y el servidor manda un enlace
// para elegir otra. La respuesta es la misma exista o no la cuenta.
// =========================================================================
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EmailOutlined } from '@mui/icons-material';
import api from '../services/api';
import TarjetaAcceso, { Aviso, estiloBoton, estiloEntrada } from '../components/auth/TarjetaAcceso';

export default function RecuperarContrasena() {
    const [email, setEmail] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [enviado, setEnviado] = useState('');
    const [error, setError] = useState('');

    const enviar = async (e) => {
        e.preventDefault();
        setError('');
        setEnviando(true);
        try {
            const res = await api.post('/auth/recuperar', { email: email.trim() });
            setEnviado(res.message || 'Si el correo corresponde a una cuenta, te hemos enviado un enlace.');
        } catch (err) {
            setError(err.message || 'No se ha podido enviar la petición. Inténtalo de nuevo.');
        } finally {
            setEnviando(false);
        }
    };

    return (
        <TarjetaAcceso
            titulo="Recuperar contraseña"
            subtitulo={enviado ? null : 'Escribe el correo con el que entras y te enviaremos un enlace para elegir una contraseña nueva.'}
        >
            {error && <Aviso>{error}</Aviso>}

            {enviado ? (
                <>
                    <Aviso tipo="ok">{enviado}</Aviso>
                    <p className="text-xs text-slate-400 font-medium text-center leading-relaxed mb-6">
                        El enlace caduca en una hora. Si no lo ves, mira en la carpeta de correo no deseado.
                    </p>
                </>
            ) : (
                <form onSubmit={enviar} className="space-y-4" noValidate>
                    <div className="relative group">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none text-slate-500 group-focus-within:text-sky-400 transition-colors">
                            <EmailOutlined fontSize="small" />
                        </div>
                        <input
                            type="email" name="email" required autoComplete="email"
                            aria-label="Correo electrónico" placeholder="Correo electrónico"
                            value={email} onChange={(e) => setEmail(e.target.value)}
                            className={estiloEntrada}
                        />
                    </div>
                    <button type="submit" disabled={enviando || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())} className={estiloBoton}>
                        {enviando ? 'Enviando…' : 'Enviar enlace'}
                    </button>
                </form>
            )}

            <div className="mt-8 pt-4 border-t border-white/5 text-center">
                <Link to="/login" className="text-xs font-bold text-sky-400 hover:text-sky-300">Volver al acceso</Link>
            </div>
        </TarjetaAcceso>
    );
}
